module.exports = __webpack_public_path__ + "static/watermark_footer_homes_desktop-45e5f1662b792cd65ad287d2ff80f63a.png";